import { isValidEmail, isValidPostCode } from '../common.js';
import axios from 'axios';

export default () => {
  return {
    open: false,
    lord: '',
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    townCity: '',
    postCode: '',
    message: '',
    feedback: '',
    processing: false,
    step: 1,
    openShareModal: false,
    linkCopied: false,

    async start(lord, useTemplate) {
      this.lord = lord;

      if (useTemplate) {
        this.message = this.$refs.message.value;
      }
      this.$watch(
        'firstName, lastName, email, address, townCity, postCode, message',
        () => {
          this.feedback = '';
        },
      );
      this.$watch('open', () => {
        if (this.open) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
      this.$watch('step', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    },

    reset() {
      this.open = false;
      this.lord = '';
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.address = '';
      this.townCity = '';
      this.postCode = '';
      this.feedback = '';
      this.processing = false;
      this.step = 1;
      this.openShareModal = false;
      this.linkCopied = false;
    },
    async submit(event) {
      event.preventDefault();
      this.processing = true;
      if (!this.validateForm()) {
        this.processing = false;
        return;
      }

      const updatedMessage = `
Dear ${this.lord},

${this.message}

Yours Sincerely,

${this.firstName} ${this.lastName}
`;

      const form = document.forms.namedItem('_writeToLord');
      const payload = new FormData(form);
      payload.set('message[body]', updatedMessage);

      const postUrl = form.action;

      try {
        await axios.post(postUrl, payload);
        this.feedback = 'Your message has been sent successfully.';
        this.step = 2;
      } catch (error) {
        this.feedback = `Something went wrong... ${error.response.data.message}`;
        this.processing = false;
        this.step = 1;
      }
    },

    validateForm() {
      if (!this.message) {
        this.processing = false;
        this.feedback = 'Please enter your message';
        this.$refs.message.focus();
        return false;
      }
      if (!this.firstName) {
        this.processing = false;
        this.feedback = 'Please enter your first name.';
        this.$refs.firstName.focus();
        return false;
      }
      if (!this.lastName) {
        this.processing = false;
        this.feedback = 'Please enter your last name.';
        this.$refs.lastName.focus();
        return false;
      }
      if (!isValidEmail(this.email)) {
        this.processing = false;
        this.feedback = 'Please enter a valid email address.';
        this.$refs.email.focus();
        return false;
      }
      if (!this.address) {
        this.processing = false;
        this.feedback = 'Please enter your address.';
        this.$refs.address.focus();
        return false;
      }
      if (!this.townCity) {
        this.processing = false;
        this.feedback = 'Please enter your town/city.';
        this.$refs.townCity.focus();
        return false;
      }
      if (!isValidPostCode(this.postCode)) {
        this.processing = false;
        this.feedback = 'Please enter your post code.';
        this.$refs.postCode.focus();
        return false;
      }
      return true;
    },
    copyLink() {
      this.$refs.link.select();
      this.$refs.link.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(this.$refs.link.value);
      this.linkCopied = true;
    },
  };
};
